import { theme } from '../../..';

export const Tooltip = ({ indexValue, value }: any) => {
  return (
    <div
      style={{
        padding: 8,
        background: theme.tooltip.container.background,
        fontSize: '12px',
      }}
    >
      {indexValue}: <strong>{value}</strong>
    </div>
  );
};